import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpRequest,
    HttpEventType,
    HttpResponse,
    HttpHeaders,
    HttpEvent
} from '@angular/common/http';
import {
    Subject,
    Observable
} from 'rxjs';

import { environment } from '../../../environments/environment';
import { CollectApiServiceBase } from './collect-api-base.service';
import { Attachment, AttachmentProperties } from '../models/attachment/attachment.model';
import { plainToClass } from "class-transformer";
import { ProgressIndicatorService } from './progress-indicator.service';

// Note:  the code in this service was derived from the following tutorial:
//        https://malcoded.com/posts/angular-file-upload-component-with-express/.

// Define a file upload progress class.
export class FileUploadProgress {
    // Progress information.
    public fileName: string;
    public progressValue: number = 0;
    public callerData: any;
}

// Export a progress hash class.
export interface IFileUploadProgressHash {
    //[fileName: string]: { progress: Observable<number> };
    [fileName: string]: { progress: Observable<FileUploadProgress> };
}

// Define an internally used class.
class FileUploadSubject<T> extends Subject<T> {
    // Properties.
    private fileName: string;

    // Constructor.
    constructor(fileNameParam: string) {
        super();

        this.fileName = fileNameParam;

        return;
    }

    // Methods.
    public get FileName(): string {
        return (this.fileName);
    }
}

@Injectable()
export class AttachmentService extends CollectApiServiceBase<Attachment> {
    
    

    // Constructor.
    constructor(http: HttpClient,
        public progressIndicatorService: ProgressIndicatorService
    ) {
        super(http, progressIndicatorService, environment.apiUrl, 'attachment', Attachment)

        return;
    }

    public viewFile(id: number): string {
        let url = `${this.url}/${this.endpoint}/view/${id}`;
        return url;
    }

    // Custom service methods.
    public uploadFiles(formInstanceElementId: number, attachmentId: number, files: Set<File>, optionalCallerData = null) {
        // this will be the our resulting map
        const status: IFileUploadProgressHash = {};
        const titles = optionalCallerData?.Titles;
        let i = 0;
        files.forEach(file => {
            // create a new multipart-form for every file
            const formData: FormData = new FormData();
            formData.append('file', file, file.name);
            formData.append('title', titles[i]);
            i++;

            // create a http-post request and pass the form
            // tell it to report the upload progress
            let httpHeaders: HttpHeaders = new HttpHeaders();

            // Construct the URL.
            let url = `${this.url}/${this.endpoint}/uploadFiles/${formInstanceElementId}/${attachmentId}`;

            // Issue the request.
            const req = new HttpRequest('POST', url, formData, {
                reportProgress: true,
                headers: httpHeaders
            });

            // create a new progress-subject for every file
            //const progress = new Subject<number>();
            //const progress = new Subject<FileUploadProgress>();
            const progress = new FileUploadSubject<FileUploadProgress>(file.name);

            // send the http-request and subscribe for progress-updates
            this.http.request(req).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {

                    // calculate the progress percentage
                    const percentDone = Math.round(100 * event.loaded / event.total);

                    // pass the percentage into the progress-stream
                    let fileUploadProgress = new FileUploadProgress();
                    fileUploadProgress.fileName = progress.FileName;
                    fileUploadProgress.progressValue = percentDone;
                    fileUploadProgress.callerData = optionalCallerData;
                    //progress.next(percentDone);

                    progress.next(fileUploadProgress);
                } else if ((event.type === HttpEventType.Sent) ||
                    (event.type === HttpEventType.ResponseHeader) ||
                    (event.type === HttpEventType.DownloadProgress)) {
                    let consoleMsg: string =
                        `AttachmentService.upload():  received an event of type ${event.type}.`;
                    console.log(consoleMsg);
                } else if (event instanceof HttpResponse) {
                    // Close the progress-stream if we get an answer form the API
                    // The upload is complete
                    let fileUploadProgress = new FileUploadProgress();
                    fileUploadProgress.fileName = progress.FileName;
                    fileUploadProgress.progressValue = 100;
                    fileUploadProgress.callerData = optionalCallerData;

                    progress.next(fileUploadProgress);

                    progress.complete();
                } else {
                    console.log("AttachmentService.upload():  received an event of an unknown type.")
                }
            });

            // Save every progress-observable in a map of all observables
            status[file.name] = {
                progress: progress.asObservable()
            };
        });

        // return the map of progress.observables
        return (status);
    }

    //public upload(files: Set<File>): { [key: string]: { progress: Observable<number> } } {
    public upload(files: Set<File>, optionalCallerData = null): IFileUploadProgressHash {
        // this will be the our resulting map
        //const status: { [key: string]: { progress: Observable<number> } } = {};
        const status: IFileUploadProgressHash = {};

        let url = `${this.url}/${this.endpoint}/upload`;

        files.forEach(file => {
            // create a new multipart-form for every file
            const formData: FormData = new FormData();
            formData.append('file', file, file.name);

            // create a http-post request and pass the form
            // tell it to report the upload progress
            let httpHeaders: HttpHeaders = new HttpHeaders();
            //httpHeaders.append('fileName', file.name);

            const req = new HttpRequest('POST', url, formData, {
                reportProgress: true,

                headers: httpHeaders
            });

            // create a new progress-subject for every file
            //const progress = new Subject<number>();
            //const progress = new Subject<FileUploadProgress>();
            const progress = new FileUploadSubject<FileUploadProgress>(file.name);

            // send the http-request and subscribe for progress-updates
            this.http.request(req).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {

                    // calculate the progress percentage
                    const percentDone = Math.round(100 * event.loaded / event.total);

                    // pass the percentage into the progress-stream
                    let fileUploadProgress = new FileUploadProgress();
                    fileUploadProgress.fileName = progress.FileName;
                    fileUploadProgress.progressValue = percentDone;
                    fileUploadProgress.callerData = optionalCallerData;
                    //progress.next(percentDone);

                    progress.next(fileUploadProgress);
                } else if ((event.type === HttpEventType.Sent) ||
                    (event.type === HttpEventType.ResponseHeader) ||
                    (event.type === HttpEventType.DownloadProgress)) {
                    let consoleMsg: string =
                        `AttachmentService.upload():  received an event of type ${event.type}.`;
                    console.log(consoleMsg);
                } else if (event instanceof HttpResponse) {
                    // Close the progress-stream if we get an answer form the API
                    // The upload is complete
                    let fileUploadProgress = new FileUploadProgress();
                    fileUploadProgress.fileName = progress.FileName;
                    fileUploadProgress.progressValue = 100;
                    fileUploadProgress.callerData = optionalCallerData;

                    let responseBody = event.body;


                    progress.next(fileUploadProgress);

                    progress.complete();
                } else {
                    console.log("AttachmentService.upload():  received an event of an unknown type.")
                }
            });

            // Save every progress-observable in a map of all observables
            status[file.name] = {
                progress: progress.asObservable()
            };
        });

        // return the map of progress.observables
        return (status);
    }

    // disabling does not hide it from the application
    public disableAttachment(attachmentId: number, appliesToAllVersions: boolean = false): Promise<Attachment> {
        let url = `${this.url}/${this.endpoint}/disable/${attachmentId}?appliesToAllVersions=${appliesToAllVersions}`;
        return this.http.delete<Attachment>(url).toPromise().then(res => {
            return res;
        });
    }

    // disabling does not hide it from the application
    public restoreAttachment(attachmentId: number, appliesToAllVersions: boolean = false): Promise<Attachment> {
        let url = `${this.url}/${this.endpoint}/enable/${attachmentId}?appliesToAllVersions=${appliesToAllVersions}`;
        return this.http.put<Attachment>(url, {}).toPromise().then(res => {
            return res;
        });
    }

    //This does an actual delete (in the sense that it sets IsDeleted and hides it from the application)
    public deleteAttachment(dataCollectionId: number,
        folderId: number,
        formInstanceId: number,
        formFieldId: number,
        fileName: string): Promise<boolean> {

        let url = `${this.url}/${this.endpoint}/delete/${dataCollectionId}/${folderId}/${formInstanceId}/${formFieldId}/${fileName}`;

        let httpHeaders: HttpHeaders = new HttpHeaders();

        const req = new HttpRequest('POST', url, {
            headers: httpHeaders
        });

        return this.http.post(url, req).toPromise().then(event => {
            if (event == 'true')
                return true;
            else
                return false;
        });
    }

    public setCustomProperties(dataCollectionId: number,
        folderId: number,
        formInstanceId: number,
        formFieldId: number,
        attachmentName: string,
        customProps: AttachmentProperties): Promise<any[]> {
        let url = `${this.url}/${this.endpoint}/setCustomProperties/${dataCollectionId}/${folderId}/${formInstanceId}/${formFieldId}/${attachmentName}`;

        return this.http.put<any[]>(url, customProps)
            .toPromise()
            .then(res => {
                return res;
            })
            .catch(this.handleError);
    }

    public updateDescription(dataCollectionId: number,
        folderId: number,
        formInstanceId: number,
        formFieldId: number,
        attachmentName: string,
        newDescription: string) {
        let url = `${this.url}/${this.endpoint}/updateDescription/${dataCollectionId}/${folderId}/${formInstanceId}/${formFieldId}/${attachmentName}/${newDescription}`;

        let httpHeaders: HttpHeaders = new HttpHeaders();

        const req = new HttpRequest('POST', url, {
            headers: httpHeaders
        });

        return this.http.post(url, req).toPromise().then(event => {
            if (event == 'true')
                return true;
            else
                return false;
        });
    }

    public renameAttachment(dataCollectionId: number,
        folderId: number,
        formInstanceId: number,
        formFieldId: number,
        attachmentName: string,
        newAttachmentName: string): Promise<boolean> {

        let url = `${this.url}/${this.endpoint}/rename/${dataCollectionId}/${folderId}/${formInstanceId}/${formFieldId}/${attachmentName}/${newAttachmentName}`;

        let httpHeaders: HttpHeaders = new HttpHeaders();

        const req = new HttpRequest('POST', url, {
            headers: httpHeaders
        });

        return this.http.post(url, req).toPromise().then(event => {
            if (event == 'true')
                return true;
            else
                return false;
        });
    }

    

    formatResponse(data: Attachment): Attachment {
        let obj = plainToClass(Attachment, data);

        return (obj);
    }

    save(data: Attachment): Promise<Attachment> {
        console.log(data.id);
        if (data.id > 0) {
            return (this.update(data));
        } else
            return (this.create(data));
    }
}
